import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchMaterials } from "../features/materials/materialSlice";

import MaterialForm from "./MaterialForm";
import MaterialTable from "./MaterialTable";

function Materials() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.despatcho
    );

    useEffect(() => {

        dispatch(fetchMaterials());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <MaterialForm />

                </div>

                <div className="col-lg-8">

                    <MaterialTable />

                </div>

            </div>

        </div>

    );

}

export default Materials;